import { createRouter, createWebHistory } from 'vue-router'

// 导入页面组件
import Login from '../views/login.vue'
import Callback from '../views/callback.vue'
import Workbench from '../views/Workbench.vue'
import Customer from '../views/Customer.vue'
import Live from '../views/Live.vue'
import Myindex from '../views/myindex.vue'
import InviteCustomers from '../views/Invitecustomers/Invitecustomers.vue'
import WriteOff from '../views/write-off/write-off.vue'
import WriteOffOrder from '../views/write-off/write-off-order.vue'
import OrderWrite from '../views/write-off/orderwrite.vue'
import WriteOffCoupon from '../views/write-off/write-off-coupon.vue'
import ShopCheckIn from '../views/shopcheckin/shopcheckin.vue'
import CheckInStatus from '../views/shopcheckin/checkinstatus.vue'
import OrderList from '../views/orderlist/orderlist.vue'
import OrderDetails from '../views/orderlist/orderdetails.vue'

// 定义路由规则
const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: '登录',
    component: Login
  },
  {
    path: '/callback',
    name: '登录回调',
    component: Callback
  },
  {
    path: '/workbench',
    name: '工作台',
    component: Workbench
  },
  {
    path: '/customer',
    name: '客户',
    component: Customer
  },
  {
    path: '/live',
    name: '直播',
    component: Live
  },
  {
    path: '/myindex',
    name: '我的',
    component: Myindex
  },
  {
    path: '/invite-customers',
    name: '邀请客户',
    component: InviteCustomers
  },
  {
    path: '/write-off',
    name: '核销',
    component: WriteOff
  },
  {
    path: '/write-off-order',
    name: '核销订单提货',
    component: WriteOffOrder
  },
  {
    path: '/orderwrite',
    name: '核销订单',
    component: OrderWrite
  },
  {
    path: '/write-off-coupon',
    name: '核销优惠券',
    component: WriteOffCoupon
  },
  {
    path: '/shopcheckin',
    name: '门店签到',
    component: ShopCheckIn
  },
  {
    path: '/checkinstatus',
    name: '签到状态',
    component: CheckInStatus
  },
  {
    path: '/orderlist',
    name: '订单列表',
    component: OrderList
  },
  {
    path: '/orderdetails',
    name: '订单详情',
    component: OrderDetails
  },



]

// 创建路由实例
const router = createRouter({
  history: createWebHistory(),
  routes
})

// 添加路由守卫，动态设置页面标题
router.beforeEach((to, from, next) => {
  // 设置页面标题为当前路由的name
  document.title = to.name || '食养集'
  next()
})

export default router
